<template>
  <v-app theme="dark">
    <RouterView />
    <PwaInstallBanner />
    <ToastContainer />
  </v-app>
</template>

<script setup>
import { RouterView } from 'vue-router'
import ToastContainer from './components/common/ToastContainer.vue'
import PwaInstallBanner from './components/common/PwaInstallBanner.vue'
</script>

<style lang="css" scoped>
@media (min-width: 768px) {
  .eruda-container .eruda-dev-tools {
    top: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    left: auto !important;
    width: 450px !important;        /* หรือกำหนดเป็น 40vw */
    max-width: 80vw !important;
    height: 100vh !important;
    box-shadow: -4px 0 16px rgba(0, 0, 0, 0.25) !important;
  }

  /* ซ่อนแถบลากปรับความสูงเดิมบนมือถือ */
  .eruda-container .eruda-resizer {
    display: none !important;
  }
}
</style>